import classnames from 'classnames';
import React, { FC, useId } from 'react';

import '@eika/toggle-switch-style';

export type BasicHTMLButtonProps = Omit<
    React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'onChange'
>;

interface ToggleSwitchProps extends BasicHTMLButtonProps {
    checked: boolean;
    onChange: (value: boolean) => void;
    ariaLabel?: string;
    disabled?: boolean;
    switchText?: [string, string];
    // @default false;
    isLoading?: boolean;
}

const ToggleSwitch: FC<ToggleSwitchProps> = ({
    checked,
    onChange,
    ariaLabel,
    disabled,
    switchText = ['På', 'Av'],
    isLoading = false,
    ...rest
}) => {
    const [onText, offText] = switchText;
    const id = useId();
    return (
        <label className="sgw-toggle-switch" aria-describedby={id}>
            <span className="sgw-toggle-switch__label" id={id}>
                {ariaLabel && <span className="screen-reader-text">{ariaLabel} - </span>}
                {checked ? onText : offText}
            </span>
            <button
                {...rest}
                type="button"
                role="switch"
                aria-checked={checked}
                aria-busy={isLoading}
                className={classnames('sgw-toggle-switch__button', {
                    checked,
                    'sgw-toggle-switch__button--pending': isLoading,
                })}
                onClick={() => onChange(!checked)}
                disabled={disabled || isLoading}
            >
                <span aria-hidden="true" className="sgw-toggle-switch__circle" />
            </button>
        </label>
    );
};

export default ToggleSwitch;
